import { DomainError, DomainErrorCode } from "~domain/global/errors/domain-error.ts";

export class InvalidCredentialsError extends DomainError {
  constructor() {
    super(DomainErrorCode.FORBIDDEN_ERROR, "Invalid Credentials");
  }
}
